import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Container, Box, Grid, TextField, Button, List, ListItem, ListItemText, Divider, makeStyles, } from '@material-ui/core';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getAssetTransferLogs, postTransferApproval } from '../../ReduxStore/VendorDataSlice';
import { convertUTCtoIST } from '../../helpers/DateConvert';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';


const useStyles = makeStyles((theme) => ({
    checkpoint_box: {
        margin: '0 auto',
        maxWidth: '950px',
        marginBottom: theme.spacing(3),
        padding: '20px',
        border: '2px solid black',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
}));


const AssetTransferDetails = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Asset Transfer Table', href: '/asset-transfer-table' }
    ];
    // const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const transfer_id = pathname[2];

    const [loading, setLoading] = useState(true);
    // const [postLoading, setPostLoading] = useState(false);
    const [loadingStates, setLoadingStates] = useState([]);
    const [assetTransfers, setAssetTransfers] = useState({});
    // const [DOA, setDOA] = useState([]);
    const [reviewComments, setReviewComments] = useState([]);

    const userRole = localStorage.getItem("userRole")

    const handleReviewCommentChange = (index, value) => {
        const updatedComments = [...reviewComments];
        updatedComments[index] = value;
        setReviewComments(updatedComments);
    };

    const handleAction = async (index, item, action) => {
        const newLoadingStates = [...loadingStates];
        newLoadingStates[index] = true; // Set loading state for the specific index
        setLoadingStates(newLoadingStates);

        const payload = {
            transfer_logs_id: transfer_id,
            level_name: item.levelname,
            level_sequence: item.level_sequence,
            comment: reviewComments[index],
            status: action
        }
        console.log("check Payload", payload)
        try {
            const action = dispatch(postTransferApproval(payload));
            const res = await action.unwrap();
            if (res.StatusCode === 200) {
                getAssetTransferDetails();
                toast.success("Success");
                // setTimeout(() => {
                //     navigate("/breakdown-management");
                // }, 2000);
            } else if (res.StatusCode === 205) {
                toast.info("Approval not allowed. Previous approvals pending");
            } else {
                toast.error("An error occurred. Please try again.");
            }
        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        } finally {
            setLoadingStates(prevStates => {
                const newLoadingStates = [...prevStates];
                newLoadingStates[index] = false;  // Reset loading state for this button
                return newLoadingStates;
            });
        }
    }


    const getAssetTransferDetails = async () => {
        try {
            const action = dispatch(getAssetTransferLogs(`?id=${transfer_id}`));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                setAssetTransfers(res.result)
            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }

    // const getDOAs = async () => {
    //     try {
    //         const action = dispatch(getTransferDOA());
    //         const res = await action.unwrap();
    //         console.log("DOA res", res.result)
    //         if (res.result) {
    //             setDOA(res.result)
    //         };
    //     } catch (error) {
    //         console.error("Error in okHandler:", error);
    //         toast.error(error.message || "No Logs Found!");
    //     }
    // }


    useEffect(() => {
        const fetchData = async () => {
            await getAssetTransferDetails();
            // await getDOAs();
            setLoading(false);
        };
        fetchData();
    }, [])





    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <ResponsiveTypography>
                        Asset Transfer Details
                    </ResponsiveTypography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Asset Transfer Details" />
                </Box>
                <Box className={classes.checkpoint_box} >
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={4}>
                            <strong>Request Ref. Number</strong>
                            <h4>{assetTransfers?.request_ref_no || "N/A"}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            Raiser Name
                            <h4>{assetTransfers.raiser_name}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            Raiser Department
                            <h4>{assetTransfers.raiser_dept}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            Transfer Date
                            <h4>{convertUTCtoIST(assetTransfers.raiser_date)}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            Reason
                            <h4>{assetTransfers.reason}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            Status
                            <h4>{assetTransfers.status}</h4>
                        </Grid>

                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={2}>
                            Current Vendor
                            <h4>{assetTransfers.old_vendor_no}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            Current Vendor Name
                            <h4>{assetTransfers.old_vendor_name}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            Current Vendor Location
                            <h4>{assetTransfers.old_vendor_location}</h4>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={2}>
                            New Vendor
                            <h4>{assetTransfers.new_vendor_no}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            New Vendor Name
                            <h4>{assetTransfers.new_vendor_name}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            New Vendor Location
                            <h4>{assetTransfers.new_vendor_location}</h4>
                        </Grid>
                    </Grid>

                </Box>
                <Box className={classes.checkpoint_box} >
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            Asset Details
                            {assetTransfers && assetTransfers.asset_details.length > 0 && (
                                <List>
                                    {assetTransfers.asset_details.map((asset, index) => {
                                        return (
                                            <div key={index}>
                                                <ListItem>
                                                    <ListItemText
                                                        primary={`${(asset.asset_no).slice(3)} | ${asset.description}`}
                                                    />
                                                </ListItem>
                                                {index < assetTransfers.asset_details.length - 1 && <Divider />}
                                            </div>
                                        );
                                    })}
                                </List>
                            )}
                        </Grid>
                    </Grid>
                </Box>

                {/* <Box className={classes.checkpoint_box}>
                    <Grid container spacing={3} className="checkpoint-header" alignItems="center">
                        <Grid item xs={2}>
                            <h3>Level Seq.</h3>
                        </Grid>
                        <Grid item xs={2}>
                            <h3>Level Name</h3>
                        </Grid>
                        <Grid item xs={2}>
                            <h3>User Name</h3>
                        </Grid>
                        <Grid item xs={2}>
                            <h3>Comment</h3>
                        </Grid>
                        <Grid item xs={2}>
                            <h3>Action</h3>
                        </Grid>
                    </Grid>
                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                    {assetTransfers && assetTransfers.doa.map((item, index) => {
                        const isUserAllowed = item.allowthisuser === true;
                        const approval = assetTransfers.approvals?.find(
                            (approval) => approval.user_name === item.user_name
                        );
                        console.log('check', approval)
                        const isApproved = approval?.status === "Approved";
                        const commentValue = isApproved ? approval.comment : reviewComments[index] || "";

                        return (
                            <React.Fragment key={index}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={2}>
                                        {item.level_sequence}
                                    </Grid>
                                    <Grid item xs={2}>
                                        {item.levelname}
                                    </Grid>
                                    <Grid item xs={2}>
                                        {item.user_name}
                                    </Grid>
                                    <Grid item xs={2}>
                                        <TextField
                                            fullWidth
                                            placeholder="Enter Comment"
                                            variant="outlined"
                                            size="small"
                                            value={commentValue}
                                            onChange={(e) => handleReviewCommentChange(index, e.target.value)}
                                            disabled={!isUserAllowed || isApproved}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Grid container spacing={1}>
                                            <Grid item>
                                                <Button
                                                    style={{
                                                        backgroundColor: isApproved ? 'green' : undefined,
                                                        color: 'white',
                                                    }}
                                                    variant="contained"
                                                    color={isApproved ? "success" : "primary"} // Green if approved
                                                    onClick={() => handleAction(index, item, "Approved")}
                                                    disabled={!isUserAllowed || isApproved || loadingStates[index]}
                                                >
                                                    {loadingStates[index] ? "Approving..." : isApproved ? "Approved" : "Approve"}
                                                </Button>
                                            </Grid>
                                            <Grid item>
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => handleAction(index, item, "Rejected")}
                                                    disabled={!isUserAllowed || isApproved || loadingStates[index]}
                                                >
                                                    {loadingStates[index] ? "Rejecting..." : "Reject"}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                            </React.Fragment>
                        );
                    })}
                </Box> */}
                <Box className={classes.checkpoint_box}>
                    <Grid container spacing={3} className="checkpoint-header" alignItems="center" style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                        <Grid item xs={4} sm={2}>
                            <h3>Level Seq.</h3>
                        </Grid>
                        <Grid item xs={4} sm={2}>
                            <h3>Level Name</h3>
                        </Grid>
                        <Grid item xs={4} sm={2}>
                            <h3>User Name</h3>
                        </Grid>
                        <Grid item xs={4} sm={2}>
                            <h3>Comment</h3>
                        </Grid>
                        <Grid item xs={4} sm={2}>
                            <h3>Action</h3>
                        </Grid>
                    </Grid>
                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                    <Box style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                        {assetTransfers && assetTransfers.doa.map((item, index) => {
                            const isUserAllowed = item.allowthisuser === true;

                            // Find the corresponding approval for the current item
                            const approval = assetTransfers.approvals?.find(
                                (approval) => approval.user_name === item.user_name
                            );

                            // Check if the current item is approved
                            const isApproved = approval?.status === "Approved";
                            const commentValue = isApproved ? approval.comment : reviewComments[index] || "";

                            return (
                                <React.Fragment key={index}>
                                    <Grid container spacing={2} alignItems="center" style={{ minWidth: '600px' }} >
                                        <Grid item xs={1} sm={2}>
                                            {item.level_sequence}
                                        </Grid>
                                        <Grid item xs={2} sm={2}>
                                            {item.levelname}
                                        </Grid>
                                        <Grid item xs={2} sm={2}>
                                            {item.user_name}
                                        </Grid>
                                        <Grid item xs={2} sm={2}>
                                            <TextField
                                                fullWidth
                                                placeholder="Enter Comment"
                                                variant="outlined"
                                                size="small"
                                                value={commentValue}
                                                onChange={(e) => handleReviewCommentChange(index, e.target.value)}
                                                disabled={!isUserAllowed || isApproved} // Disable if already approved
                                            />
                                        </Grid>
                                        <Grid item xs={5} sm={4}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={6} sm={5}>
                                                    <Button
                                                        style={{
                                                            backgroundColor: isApproved ? 'green' : undefined,
                                                            color: 'white',
                                                        }}
                                                        variant="contained"
                                                        color={isApproved ? "success" : "primary"}
                                                        onClick={() => handleAction(index, item, "Approved")}
                                                        disabled={!isUserAllowed || isApproved || loadingStates[index]}
                                                    >
                                                        {loadingStates[index] ? "Approving..." : isApproved ? "Approved" : "Approve"}
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={6} sm={5} >
                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={() => handleAction(index, item, "Rejected")}
                                                        disabled={!isUserAllowed || isApproved || loadingStates[index]} // Disable if approved
                                                    >
                                                        {loadingStates[index] ? "Rejecting..." : "Reject"}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                                </React.Fragment>
                            );
                        })}
                    </Box>
                </Box>


                {/* <Box style={{ margin: '0 auto', maxWidth: '850px', marginBottom: "12px" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={6}>
                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                style={{ borderRadius: "8px", fontSize: "16px", backgroundColor: "red", color: "white" }}
                                onClick={rejectHandler}
                                startIcon={rejectLoading ? <CircularProgress size={20} /> : <NotInterestedIcon />}
                                disabled={rejectLoading}
                            >
                                {rejectLoading ? "Rejecting" : "Reject"}
                            </Button>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                style={{ borderRadius: "8px", fontSize: "16px" }}
                                onClick={approveHandler}
                                startIcon={postLoading ? <CircularProgress size={20} /> : <CheckIcon />}
                                disabled={postLoading}
                            >
                                {postLoading ? "Approving" : "Approve"}
                            </Button>
                        </Grid>
                    </Grid>
                </Box> */}

            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default AssetTransferDetails;
